import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
import { grey } from "@mui/material/colors";
import { useMemo, useRef } from "react";
import { Field } from "react-final-form";
import SignatureCanvas from "react-signature-canvas";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import Flx from "../../layout/Flx";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffSignatureField = ({
  name,
  label,
  required = false,
  suppressGrid,
  size,
  sx,
  height = `210px`,
  canvasProps = { width: "100%", height, className: "sigCanvas" },
}) => {
  const signatureRef = useRef(null);

  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required]
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
    >
      <Field
        name={name}
        validate={validate}
        subscription={{ value: true, error: true, touched: true }}
        render={({ input, meta }) => {
          function handleEnd() {
            if (!signatureRef.current) return;
            try {
              const trimmedCanvas = signatureRef.current.getTrimmedCanvas();
              input.onChange(trimmedCanvas.toDataURL("image/png"));
            } catch (error) {
              const rawCanvas = signatureRef.current.getCanvas();
              input.onChange(rawCanvas.toDataURL("image/png"));
            }
          }
          function clearSignature() {
            if (!signatureRef.current) return;
            signatureRef.current.clear();
            input.onChange(null); // Clear form value
          }
          return (
            <Flx column>
              <Box
                sx={{
                  border: `1px solid ${grey[300]}`,
                  borderRadius: "4px",
                  canvas: {
                    width: "100%",
                    height: canvasProps.height,
                  },
                }}
              >
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  onEnd={handleEnd}
                  {...canvasProps}
                  style={sx}
                />
              </Box>
              <Flx column>
                {input.value ? (
                  <Button variant="text" onClick={clearSignature}>
                    Clear Signature
                  </Button>
                ) : null}
              </Flx>
              {meta.touched && meta.error && (
                <FormHelperText sx={{ ml: 3 }} error>
                  {meta.error}
                </FormHelperText>
              )}
            </Flx>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffSignatureField;
